"use client";

import Link from "next/link";
import type { LinkProps } from "next/link";
import type { AnchorHTMLAttributes, ReactNode } from "react";
import { useTrackEvent } from "@/hooks/useTrackEvent";

type TrackedLinkProps = LinkProps & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  children: ReactNode;
  className?: string;
  eventName?: string;
  eventProperties?: Record<string, unknown>;
};

export function TrackedLink({ eventName, eventProperties, children, onClick, ...rest }: TrackedLinkProps) {
  const trackEvent = useTrackEvent();

  return (
    <Link
      {...rest}
      onClick={(event) => {
        onClick?.(event);
        if (eventName) {
          const hrefValue = typeof rest.href === "string" ? rest.href : undefined;
          trackEvent(eventName, { href: hrefValue, ...eventProperties });
        }
      }}
    >
      {children}
    </Link>
  );
}

type TrackedAnchorProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  href: string;
  children: ReactNode;
  eventName?: string;
  eventProperties?: Record<string, unknown>;
};

export function TrackedAnchor({ href, eventName, eventProperties, children, onClick, ...rest }: TrackedAnchorProps) {
  const trackEvent = useTrackEvent();

  return (
    <a
      {...rest}
      href={href}
      onClick={(event) => {
        onClick?.(event);
        if (eventName) trackEvent(eventName, { href, ...eventProperties });
      }}
    >
      {children}
    </a>
  );
}
